import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import store from "./store";

const persistor = persistStore(store);

const validate_storage = () => {
    let local_storage = window.localStorage.getItem("persist:root");
    if (local_storage) {
        try {
            let version_config_redux = store.getState()._persist.version;
            let version_local_storage = JSON.parse(JSON.parse(local_storage)._persist).version;
            if (version_config_redux !== version_local_storage) {
                return false;
            }
        } catch (error) {
            return false;
        }
    }
    return true;
};

if (validate_storage()) {
        ReactDOM.createRoot(document.getElementById("root")).render(
            <Provider store={store}>
                <BrowserRouter>
                    <PersistGate persistor={persistor}>
                        <App />
                    </PersistGate>
                </BrowserRouter>
            </Provider>
        );
} else {
    setTimeout(() => {
        window.localStorage.removeItem("persist:root");
        window.localStorage.removeItem("persist:token");
    }, 1000);
    setTimeout(() => {
        window.location.reload();
    }, 2000);
}
